import { render } from "./QuestionariView.vue?vue&type=template&id=3457c1c2"
import script from "./QuestionariView.vue?vue&type=script&lang=js"
export * from "./QuestionariView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__